module.exports = __webpack_public_path__ + "static/media/LogoGovoLegalBcotrs.6137c878.png";